
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';


import { FormGroup } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';


import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { SuppliesRequests } from '../../../../interfaces/SuppliesRequests';
import { SuppliesService } from '../../../../services/supplies';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { ItemsService } from '../../../../services/items.service';


@Component({
  selector: 'app-suppliespage',
  templateUrl: './suppliespage.component.html',
  styleUrl: './suppliespage.component.scss'
})
export class SuppliespageComponent {

  allData: SuppliesRequests[] = [];
  totalItems = 0;
  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ["id", 'created_at', 'supplier_name', 'items', 'created_by', 'accepted_by', 'status', 'note'];
  isActive = true;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  FilterDataForm!: FormGroup;
  userId!: string;
  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  showinstalimentPopUp: boolean = false;
  isMobile: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  not_payed: string = '';
  payed: string = '';
  instaliment_price: string = '';
  instaliment_period: string = '';
  payedId!: any;
  dataSource: MatTableDataSource<any>;
  warehouseid!: any;
  allWareHouses: any[] = [];
  newPage: number = 1;
  warehouseType: boolean = false;
  isWarehouse: boolean = false;
  get canShowStockTransfer(): boolean {
    return this.isAdmin && this.allWareHouses.length > 1;
  }
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _FinancialManager: FinancialManagerService,
    private _suppliesService: SuppliesService,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private deviceService: DeviceDetectorService,
    private excelExportService: ExcelExportService
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.warehouseid = localStorage.getItem("posId");
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res?.warehouse || [];
      },
      error: (err) => {

      },
    });
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
        if (this.isAdmin)
          this.displayedColumns.push('type', 'delete');
        this.getAllSuppliesData(this.newPage, this.warehouseid);
        this._userService.getWarehouseType(Number(this.warehouseid)).subscribe({
          next: (data) => {
            if (data['warehouses_type'] != "1") {

              this.isWarehouse = true;
            }
            else this.isWarehouse = false;
          }
        });
      },
      error: (error) => console.error(error),
    });
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];
      },
      error: (error) => console.error(error),
    });

  }
  resetPagination() {
    if (this.paginator) this.paginator.firstPage();
    this.newPage = 1;
  }
  accStatement(phone: string) {
    this.getStatementByPhone(phone);
  }
  applyWareHouse(warehouseId: any) {
    this.resetPagination();
    this.warehouseid = warehouseId;
    this.getAllSuppliesData(this.newPage, warehouseId);
  }
  tolist(list: any) {
    return String(list).split(",");
  }
  drawProducts(element: any, price: any, qty: any, newPrice: any, newqty: any) {
    var x = parseInt(price) * parseInt(qty);
    var y = parseInt(newqty) * parseInt(newPrice);
    var z = parseInt(qty) + parseInt(newqty);
    var zz = x + y;
    var defference = Math.ceil(zz / z);
    if (!this.isAr)
      return element + ' : price ' + price + ' - quantity ' + qty + ' | new price ' + defference + ' - new quantity ' + (parseInt(newqty) + parseInt(qty)) + " defference is " + (defference - parseInt(price));
    else
      return element + ' : السعر ' + price + ' - الكمية ' + qty + ' | السعر هيبقي ' + defference + ' - الكمية هتبقي ' + (parseInt(newqty) + parseInt(qty)) + " فرق بين السعرين هو " + (defference - parseInt(price));
  }
  exportToExcel(): void {

    this.contentReady = true;
    this.searched = false;
    this._homeService.getAllItems().subscribe({
      next: (data) => {
        this.allData = data.reverse();
        this.stockTotal = data.length
        this.dataSource = new MatTableDataSource(this.allData);
        this.excelExportService.exportToExcel('stocktable', 'BlueBox Stock', ['delete']);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });



  }
  changeQuantity(item: any): void {
    this.showRejectPopUp = true;
    this.itemId = item;
  }
  close(): void {
    this.showRejectPopUp = false;
    this.showinstalimentPopUp = false;
  }
  sumArray(array: any[], qty: any[]): number {
    let fixedArray = [];
    for (let i = 0; i < array.length; i++) {
      // Assuming 'array' is an array of objects, e.g., [{ price: '10', qty: '2' }, ...]
      fixedArray.push(parseInt(array[i]) * parseInt(qty[i])); // Assuming `price` and `qty` are properties of the objects
    }
    console.log(fixedArray.reduce((sum: number, value: number) => sum + value, 0))
    // Sum the values and return the total
    return fixedArray.reduce((sum: number, value: number) => sum + value, 0);
  }
  addEx(orderid: any, total: any) {
    const bonusPayload = {
      warehouse_id: localStorage.getItem("posId"),
      employee_id: this.userId,
      username: localStorage.getItem("username"),
      amount: total,
      note: String(orderid),
      type: "4"
    };
    this._FinancialManager.addexpenses(bonusPayload).subscribe({
      next: (data) => {

      },
      error: (error) => console.error(error),
    });
  }
  acceptRequest(id: string, productsIds: any, qtys: any, prices: any, cost: any, costqty: any, type: any, payed: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: this.isAr ? "عايز السعر يسمع" : "update prices?",
          showCancelButton: true,
          confirmButtonText: this.isAr ? "اه" : "YES",
          cancelButtonText: this.isAr ? "لا" : "no"
        }).then((result) => {
          if (result.isConfirmed) {
            this.contentReady = true;
            this._suppliesService.updateStockAfterAccept(id, productsIds, qtys, prices).subscribe({
              next: (res) => {
                this.contentReady = false;
                Swal.fire({
                  icon: 'success',
                  title: this.isAr ? "تم تحديث المخزون بنجاح" : 'Stock Updated Successfully',
                  confirmButtonText: this.isAr ? 'تمام' : 'ok',
                });
                this._suppliesService.acceptSupplyRequest(id, true, this.userId).subscribe({
                  next: (res) => {
                    this.contentReady = false;
                    if (this.isWarehouse) {

                      if (type == 1) {
                        this.addEx(id, payed)
                      }
                      else {
                        this.addEx(id, this.sumArray(cost, costqty))
                      }

                    }
                    this.getAllSuppliesData(this.newPage, this.warehouseid);
                  },
                  error: (err) => {
                    this.contentReady = false;
                  }
                });
              },
              error: (err) => {
                this.contentReady = false;
                Swal.fire({
                  icon: 'error',
                  title: this.isAr ? "فشل في تحديث المخزون" : 'Failed to Update Stock',
                  confirmButtonText: this.isAr ? 'تمام' : 'ok',
                });
                console.error('Stock update error:', err);
              }
            });
          }
          else {
            this._suppliesService.acceptSupplyRequest(id, true, this.userId).subscribe({
              next: (res) => {
                for (let i = 0; i < prices.length; i++) {
                  prices[i] = 0;
                }
                this._suppliesService.updateStockAfterAccept(id, productsIds, qtys, prices).subscribe({
                  next: (res) => {
                    this.contentReady = false;
                    Swal.fire({
                      icon: 'success',
                      title: this.isAr ? "تم تحديث المخزون بنجاح" : 'Stock Updated Successfully',
                      confirmButtonText: this.isAr ? 'تمام' : 'ok',
                    });
                  },
                  error: (err) => {
                    this.contentReady = false;
                    Swal.fire({
                      icon: 'error',
                      title: this.isAr ? "فشل في تحديث المخزون" : 'Failed to Update Stock',
                      confirmButtonText: this.isAr ? 'تمام' : 'ok',
                    });
                    console.error('Stock update error:', err);
                  }
                });
                this.contentReady = false;
                if (this.isWarehouse) {

                  if (type == 1) {
                    this.addEx(id, payed)
                  }
                  else {
                    this.addEx(id, this.sumArray(cost, costqty))
                  }

                }

                this.getAllSuppliesData(this.newPage, this.warehouseid);
              },
              error: (err) => {
                this.contentReady = false;
              }
            });
          }
        });

      }
    });
  }
  rejectRequest(id: string) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._suppliesService.acceptSupplyRequest(id, false, this.userId).subscribe({
          next: (res) => {
            this.contentReady = false;
            Swal.fire({
              icon: 'success',
              title: this.isAr ? "تم رفض الطلب بنجاح" : 'Request Rejected Successfully',
              confirmButtonText: this.isAr ? 'تمام' : 'ok',
            });
            this.getAllSuppliesData(this.newPage, this.warehouseid);
          },
          error: (err) => {
            this.contentReady = false;
            Swal.fire({
              icon: 'error',
              title: this.isAr ? "فشل رفض الطلب" : 'Failed to Reject Request',
              confirmButtonText: this.isAr ? 'تمام' : 'ok',
            });

          }
        });
      }
    });
  }
  getNewPrice(price: any, qty: any, newPrice: any, newqty: any) {

    var defferenceprice;
    const newPriceArray: any[] = [];
    price.forEach((element: number) => {
      var i = price.indexOf(element);
      console.log(i);
      var x = parseInt(price[i]) * parseInt(qty[i]);
      var y = parseInt(newqty[i]) * parseInt(newPrice[i]);
      var z = parseInt(qty[i]) + parseInt(newqty[i]);
      var zz = x + y;
      defferenceprice = Math.ceil(zz / z) - parseInt(price);
      newPriceArray.push(defferenceprice)
      console.log(defferenceprice);
    });

    return newPriceArray
  }
  deleteitem(id: string) {

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._homeService.delete(id).subscribe({
          next: (res) => {
            //   this.getAllStockData(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });

  }
  getStatementByPhone(phone: string) {
    this.router.navigate(['/accountstatement'], { queryParams: { phone: phone } });
  }
  getAllSuppliesData(page: any, warehouse_id: any) {
    this.contentReady = true;
    this.searched = false;
    this._suppliesService.getSuppliesRequests(page, warehouse_id).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  onPaginateChange(event: PageEvent) {
    this.newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllSuppliesData(this.newPage, this.warehouseid);
  }
  details(element: any) {
    this.router.navigate(
      ['/supplieinvoice'],
      { queryParams: { id: element.id } }
    );
  }

  changeCredit(id: any, not_payed: any, payed: any) {
    this.not_payed = not_payed;
    this.payed = payed;
    this.payedId = id;
    this.showRejectPopUp = true;
  }
  changeInstalimentValues(id: any, instaliment_price: any, instaliment_period: any) {
    this.instaliment_period = instaliment_period;
    this.instaliment_price = instaliment_price;
    this.payedId = id;
    this.showinstalimentPopUp = true;
  }

  onSubmit() {
    this.close();
    if (this.not_payed != null && this.payed != null && this.payedId != null) {
      this.contentReady = true;
      this._suppliesService.changeCreditValues(this.payedId, this.payed, this.not_payed).subscribe({
        next: (data) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم تحديث القيم بنجاح" : 'Values Updated Successfully',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.close();
          this.getAllSuppliesData(this.newPage, this.warehouseid);
        },
        error: (error) => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: this.isAr ? "فشل في تحديث القيم" : 'Failed to Update Values',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
        },
      });
    }
  }
  onSubmitInstaliment() {
    this.close();
    if (this.instaliment_period != null && this.instaliment_price != null && this.payedId != null) {
      this.contentReady = true;
      this._suppliesService.changeInstalimentValues(this.payedId, this.instaliment_price, this.instaliment_period).subscribe({
        next: (data) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم تحديث القيم بنجاح" : 'Values Updated Successfully',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.close();
          this.getAllSuppliesData(this.newPage, this.warehouseid);
        },
        error: (error) => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: this.isAr ? "فشل في تحديث القيم" : 'Failed to Update Values',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
        },
      });
    }
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }

  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._homeService.searchStock(this.searchKey).subscribe({
        next: (data) => {
          this.allData = data;
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }




}
